@use "@design/design-tokens/typography/typography" as *;
@use "@design/design-tokens/border-radius/border-radius" as *;

.root {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.titleWrapper {
  display: flex;
  flex-direction: column;
}

.sectionTitle {
  :global(p) {
    @include typography-v2-title-md;
    text-underline-offset: 8px;
  }

  :global(a > div) {
    margin-bottom: 4px;
  }
}

.subtitleLabel {
  @include typography-v2-body-xs;
  color: var(--text-soft);
}

.pieChartWrapper {
  padding: 0 20px;
  width: 100%;
  height: 100%;
}

.skeletonLoaderWrapper {
  height: 100%;
}
